export default __webpack_public_path__ + "static/media/deej-logo.d133aab8.svg";